// extracted by mini-css-extract-plugin
module.exports = {"grid":"HowItWorks_grid__n3BOF","card":"HowItWorks_card__gd2p3","number":"HowItWorks_number__eoMVK","cardTitle":"HowItWorks_cardTitle__Sukge"};